import React from 'react';
import { isQueryEmpty, reactQueryBuilder } from 'shared/utils/queryBuilder';
import { Card, Switch, Tag, Space } from 'antd';
import PreviewDates, { PeriodLabel } from 'components/DateRangePicker/date-preview';
import SortableList from 'components/SortableList';
import { gql } from '@apollo/client';
import { useQuery } from 'hooks/apollo';
import { COMPARE_PERIOD } from 'shared/constants/date';

const { formatQuery, defaultRuleProcessorNL } = reactQueryBuilder;

const SEGMENTS_QUERY = gql`
  query Segments {
    segments {
      id
      title
    }
  }
`;

const getQuerySummary = (query, segments) => {
  if (isQueryEmpty(query)) {
    return '';
  }
  const ruleProcessor = (rule, options) => {
    if (rule.field === 'segment') {
      return `Predefined segment <b>${segments?.find((s) => s.id === rule.value)?.title || rule.value}</b>`;
    }
    return defaultRuleProcessorNL(rule, options);
  };

  return formatQuery(query, { format: 'natural_language', ruleProcessor });
};

const GlobalFilterSegment = ({ value, onChange, onEdit, mainSegment, mainDateRangeConfig }) => {
  const onToggle = (enabled, e) => {
    e.stopPropagation();
    onChange({ ...value, enabled });
  };
  const { data } = useQuery(SEGMENTS_QUERY);

  const isMain = value.id === mainSegment?.id;
  let dateRangeConfig = value.dateRangeConfig || mainDateRangeConfig;
  let comparePeriod = false;

  if (value.dateRangeConfig?.compareToPrevious) {
    dateRangeConfig = { ...mainDateRangeConfig, compareToPrevious: true, comparePeriod: value.dateRangeConfig.comparePeriod };
    comparePeriod = value.dateRangeConfig.comparePeriod;
  }

  const isEmpty = (!value.dateRangeConfig && isQueryEmpty(value.query)) || !value.enabled;

  return (
    <Card
      className={`segment-card ${isEmpty ? 'empty' : ''} ${value.enabled ? 'enabled' : 'disabled'}`}
      style={value.enabled ? { '--ant-card-color': value.color } : undefined}
      hoverable={onEdit}
      size="small"
      title={(
        <Space>
          {onEdit && <SortableList.Handle />}
          {value?.title}
        </Space>
      )}
      extra={(
        <>
          {isMain && <Tag>Main segment</Tag>}
          <Switch size="small" checked={value.enabled} onChange={onToggle} />
        </>
      )}
      onClick={onEdit ? () => onEdit(value) : undefined}
    >
      <Space direction="vertical">
        {comparePeriod === COMPARE_PERIOD.PERIOD && (
          <>Previous period</>
        )}
        {comparePeriod === COMPARE_PERIOD.YEAR && (
          <>Previous year</>
        )}
        {!comparePeriod && value.dateRangeConfig && (
          <PeriodLabel dateRange={dateRangeConfig} />
        )}
        {value.dateRangeConfig && <PreviewDates dateRange={dateRangeConfig} compareOnly={comparePeriod} mainOnly={!comparePeriod} />}
        <div dangerouslySetInnerHTML={{ __html: getQuerySummary(value.query, data?.segments) }} />
      </Space>
    </Card>
  );
};

export default GlobalFilterSegment;
